import { render, staticRenderFns } from "./Reguster.vue?vue&type=template&id=3cf71ff1&scoped=true"
import script from "./Reguster.vue?vue&type=script&lang=js"
export * from "./Reguster.vue?vue&type=script&lang=js"
import style0 from "./Reguster.vue?vue&type=style&index=0&id=3cf71ff1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf71ff1",
  null
  
)

export default component.exports